"use client";
import React, { useState } from "react";
import { motion } from "motion/react";

interface Testimonial {
  text: string;
  image?: string;
  name: string;
  role: string;
  proofImage?: string;
}

export const TestimonialsColumn = (props: {
  className?: string;
  testimonials: Testimonial[];
  duration?: number;
}) => {
  const [hovered, setHovered] = useState(false);
  const baseDuration = props.duration || 10;

  return (
    <div
      className={props.className}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <motion.div
        animate={{ translateY: "-50%" }}
        transition={{
          duration: hovered ? baseDuration * 6 : baseDuration,
          repeat: Infinity,
          ease: "linear",
          repeatType: "loop",
        }}
        className="flex flex-col gap-6 pb-6"
      >
        {[
          ...new Array(2).fill(0).map((_, index) => (
            <React.Fragment key={index}>
              {props.testimonials.map(({ text, image, name, role, proofImage }, i) => (
                <div
                  className="rounded-2xl border border-border bg-card p-6 shadow-sm"
                  key={`${index}-${i}`}
                >
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {text}
                  </p>
                  {proofImage && (
                    <img
                      src={proofImage}
                      alt="Result screenshot"
                      className="mt-3 w-full rounded-lg border border-border"
                    />
                  )}
                  <div className="mt-4 flex items-center gap-3">
                    {image ? (
                      <img
                        src={image}
                        alt={name}
                        className="h-10 w-10 rounded-full object-cover"
                      />
                    ) : (
                      <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center text-sm font-bold text-primary">
                        {name.charAt(0)}
                      </div>
                    )}
                    <div>
                      <p className="text-sm font-semibold text-foreground">
                        {name}
                      </p>
                      <p className="text-xs text-muted-foreground">{role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </React.Fragment>
          )),
        ]}
      </motion.div>
    </div>
  );
};
